// extracted by mini-css-extract-plugin
module.exports = {"common":"common_common__Yumkn","body":"common_body__LryFx","full-content":"common_full-content__sf_I9"};